<template>
  <div
    class="form-login">
    <LoginDoubleParts
      v-bind="$attrs"
      :is-archlight="isArchlight" />
    <div
      class="form-login__container"
      :class="{'signup': isSignUpPage}">
      <slot />
      <LoginUsingSocial v-if="showLoginUsingSocial" />
      <slot name="footer-image" />
    </div>
  </div>
</template>
<script>
import LoginDoubleParts from './LoginDoubleParts';
import LoginUsingSocial from './LoginUsingSocial';
export default {
  name: 'AppLoginPageLayout',
  components: {
    LoginDoubleParts,
    LoginUsingSocial,
  },
  props: {
    isArchlight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showLoginUsingSocial() {
      return ['sign-up', 'login', 'archlight-login', 'archlight-sign-up'].includes(this.$route.name);
    },
    isSignUpPage() {
      return ['sign-up', 'archlight-sign-up'].includes(this.$route.name);
    },
  },
};
</script>
<style lang="scss" scoped>
.form-login__container.signup,
.form-login__container.archlight-sign-up {
  margin-left: 47%;
  @media only screen and (max-width: 1255px)  {
    margin-left: 58%;
  }
}
</style>
